import { render, staticRenderFns } from "./WHeader.vue?vue&type=template&id=9d6fccda&scoped=true&"
import script from "./WHeader.vue?vue&type=script&lang=js&"
export * from "./WHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6fccda",
  null
  
)

export default component.exports